import { Action as PolicyAction, HomePolicy } from '@models/swagger';
import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './policy.actions';
import cloneDeep from 'clone-deep';

export interface State {
  policy: HomePolicy;
  selectedAction: PolicyAction | null;
}

export const featureKey = 'flowDataPolicy';

export const initialState: State = {
  policy: {},
  selectedAction: null,
};

export function policyReducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(Actions.PolicyClearData, state => ({ ...state, policy: {} })),
    on(Actions.PolicyUpdatePolicy, (state, { data }) => ({ ...state, policy: cloneDeep(data) })),
    on(Actions.PolicyEmptyPolicy, state => ({ ...state, policy: {} })),
    on(Actions.PolicySelectAction, (state, { data }) => ({ ...state, selectedAction: cloneDeep(data) })),
    on(Actions.PolicyEmptySelectedAction, state => ({ ...state, selectedAction: null }))
  )(state, action);
}
